import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { item } from './styles';

export interface ButtonListItemProps {
  text: string;
  onClick: () => void;
  icon: React.ReactElement;
}

const ButtonListItem: React.FC<ButtonListItemProps> = ({ text, onClick, icon }) => (
  <ListItem disablePadding>
    <ListItemButton onClick={onClick} sx={item}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText sx={{ marginTop: 1.3 }}>{text}</ListItemText>
    </ListItemButton>
  </ListItem>
);

export default ButtonListItem;
